import {
  ContactPersonsFilterListAction,
  SUCCESS_FETCH_CONTACT_PERSONS_FILTER_LIST,
} from '../actions/contactPersonsFilterList'

export type ContactPersonsFilterListState = {
  data: {
    id: number
    firstName: string
    lastName: string
  }[]
}

const init: ContactPersonsFilterListState = {
  data: [],
}

export default function contactPersons(
  state: ContactPersonsFilterListState = init,
  action: ContactPersonsFilterListAction
) {
  switch (action.type) {
    case SUCCESS_FETCH_CONTACT_PERSONS_FILTER_LIST:
      return { ...state, data: action.payload.users }
  }

  return state
}
